/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Category_System_DesignInputs */

const en_blog_category_system_design = /** @type {(inputs: Blog_Category_System_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`System design`)
};

const lv_blog_category_system_design = /** @type {(inputs: Blog_Category_System_DesignInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistēmas uzbūve`)
};

/**
* | output |
* | --- |
* | "System design" |
*
* @param {Blog_Category_System_DesignInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const blog_category_system_design = /** @type {((inputs?: Blog_Category_System_DesignInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Category_System_DesignInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_blog_category_system_design(inputs)
	return en_blog_category_system_design(inputs)
});